// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fd5de016","455":"9514088f","977":"ef8271ec"}[chunkId] + ".chunk.js";
};